// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__eXCwJ","containerItemsCenter":"Skeleton_containerItemsCenter__i16QG"};